import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../Config.js';
import './Invoice.css'; // Import the custom CSS file
import PrintBillModal from '../print/PrintBillModal.js';

const Invoice = () => {
    const [mobileNo, setMobileNo] = useState('');
    const [storeId, setStoreId] = useState('');
    const [billingData, setBillingData] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [mobileError, setMobileError] = useState('');
    const [stores, setStores] = useState([]);
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [billInfo, setBillInfo] = useState(null);

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const response = await axios.post(`${API_BASE_URL}/store/getAllStores`);
                setStores(response.data);
            } catch (error) {
                console.error("Failed to fetch stores:", error);
            }
        };
        fetchStores();
    }, []);

    const handleMobileChange = (e) => {
        const value = e.target.value;
        const isValid = /^[0-9]*$/.test(value); // Allow only numbers

        if (isValid && value.length <= 10) {
            setMobileNo(value);
            setMobileError('');
        } else {
            setMobileError('Mobile number must be a valid 10-digit number.');
        }
    };

    const fetchBillingDetails = async () => {
        if (mobileNo.length !== 10) {
            setMobileError('Mobile number must be exactly 10 digits.');
            return;
        }

        try {
            const response = await axios.get(`${API_BASE_URL}/invoice/customerBillingList`, {
                params: { mobileNo, storeId }
            });
            setBillingData(response.data);
            setErrorMessage('');
        } catch (error) {
            setErrorMessage('No billing records found for this customer.');
            setBillingData([]);
        }
    };

    const downloadPDF = async (billNo, storeId, customerName) => {
        try {
            const storeConfig = JSON.parse(sessionStorage.getItem("storeConfig") || "{}");
            const printType = (storeConfig.printType || "PDF").trim().toUpperCase();

            if (printType === "THERMAL") {
                // For thermal printing, fetch the bill data and show the modal
                const response = await axios.get(`${API_BASE_URL}/invoice/getBill`, {
                    params: { billNo, storeId, printType }
                });
                
                // Set bill info and show modal
                setBillInfo(response.data);
                setShowPrintModal(true);
            } else {
                // For PDF printing, download the file
                const response = await axios.get(`${API_BASE_URL}/invoice/getBill`, {
                    params: { billNo, storeId, printType },
                    responseType: 'blob'
                });
                
                const pdfUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = pdfUrl;
                link.setAttribute('download', `${customerName}_${billNo}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Failed to process bill:", error);
            setErrorMessage('Failed to process the bill. Please try again.');
        }
    };

    return (
        <div className="customer-invoice">
            <h1 className="customer-invoice__heading">Soganis Dresses</h1>
            <div className="customer-invoice__form-container">
                <h2 className="customer-invoice__subheading">Customer Billing Details</h2>
                <div className="customer-invoice__form-group">
                    <label htmlFor="mobileNo" className="customer-invoice__label">Mobile Number:</label>
                    <input
                        type="text"
                        id="mobileNo"
                        className="customer-invoice__input-field"
                        value={mobileNo}
                        onChange={handleMobileChange}
                    />
                    {mobileError && <p className="customer-invoice__error-message">{mobileError}</p>}
                </div>
                <div className="customer-invoice__form-group">
                    <label htmlFor="storeId" className="customer-invoice__label">Store:</label>
                    <select
                        id="storeId"
                        className="customer-invoice__input-field"
                        value={storeId}
                        onChange={(e) => setStoreId(e.target.value)}
                    >
                        <option value="">Select Store</option>
                        {stores.map(store => (
                            <option key={store.storeId} value={store.storeId}>
                                {store.storeName} - {store.address}
                            </option>
                        ))}
                    </select>
                </div>
                <button className="customer-invoice__fetch-button" onClick={fetchBillingDetails}>
                   Get Bill
                </button>

                {errorMessage && <p className="customer-invoice__error-message">{errorMessage}</p>}

                {billingData.length > 0 && (
                    <div className="customer-invoice__table-container">
                        <table className="customer-invoice__billing-table">
                            <thead>
                                <tr>
                                    <th>Bill No</th>
                                    <th>Date</th>
                                    <th>Customer Name</th>
                                    <th>Payment Mode</th>
                                    <th>School Name</th>
                                    <th>Final Amount</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {billingData.map((bill) => (
                                    <tr key={bill.billNo}>
                                        <td>{bill.billNo}</td>
                                        <td>{new Date(bill.bill_date).toLocaleDateString('en-GB')}</td>
                                        <td>{bill.customerName}</td>
                                        <td>{bill.paymentMode}</td>
                                        <td>{bill.schoolName}</td>
                                        <td>{bill.final_amount}</td>
                                        <td>
                                            <button
                                                className="customer-invoice__download-button"
                                                onClick={() => downloadPDF(bill.billNo, bill.storeId, bill.customerName)}
                                            >
                                                Download PDF
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Print Bill Modal for Thermal Printing */}
            {/* Uncomment and use your actual PrintBillModal component */}
            <PrintBillModal 
                isOpen={showPrintModal}
                onClose={() => setShowPrintModal(false)}
                billInfo={billInfo}
            />
        </div>
    );
};

export default Invoice;